import React from 'react';
import { Row, Col, Label } from 'react-bootstrap';
import moment from 'moment';
import { humanize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import HeadingDivider from './HeadingDivider';

class ExceptionDetails extends React.Component {
  render() {
    const { t } = this.props;
    if (!this.props.exception) return <div>{t('LOADING')}</div>;

    const status = this.props.exception.resolved
      ? t('RESOLVED')
      : t('UNRESOLVED');

    return (
      <div>
        <HeadingDivider text={t('EXCEPTION_STATUS')} />
        <Row>
          <Col md={12}>
            <Label bsStyle="danger">{humanize(status)}</Label>
          </Col>
        </Row>
        <Row style={{ paddingTop: 5 }}>
          <Col md={3}>
            <span style={{ color: 'gray' }}>{t('CREATED')}</span>
          </Col>
          <Col md={9}>
            {moment(this.props.exception.created_at).format('L LT')} -{' '}
            {moment(this.props.exception.created_at).fromNow()}...
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <span style={{ color: 'gray' }}>{t('SUMMARY')}</span>
          </Col>
          <Col md={9}>{this.props.exception.message}</Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(ExceptionDetails);
